import { useMemo } from 'react';
import { useLocalizeMessage } from 'libs.nucleus';
import { useConsentStateContext } from './use_consent_context.hook';
import { SIGNER_ROLES } from '../constants/consent_element_types.constants';
export const useConsentSignerRoles = () => {
    const translate = useLocalizeMessage();
    return useMemo(() => SIGNER_ROLES.map((role) => ({
        value: role.value,
        label: translate(role.label),
    })), [translate]);
};
/**
 * Returns the active document's custom role names as dropdown options.
 * Returns an empty array when no custom roles have been defined.
 */
export const useDocumentSignerRoles = () => {
    const { activeDocument } = useConsentStateContext();
    return useMemo(() => (activeDocument?.roles ?? []).filter((r) => r.role.trim()).map((r) => ({ value: r.role, label: r.role })), [activeDocument?.roles]);
};
